import { RootState } from "../..";

export const selectRegistrationData = (state: RootState) => ({
    countries: state.auth.countries,
    regionsByCountry: state.auth.regionsByCountry,
    specializations: state.auth.specializations,
    mainInterests: state.auth.mainInterests,
});

export const selectLoginFormData = (state: RootState) => state.auth.loginFormData;

export const selectRegisterFormData = (state: RootState) => state.auth.registerFormData;

export const selectRegistrationStatus = (state: RootState) => ({
    registerPageIsLoading: state.auth.registerPageIsLoading,
    successfullyRegisteredForEmail: state.auth.successfullyRegisteredForEmail,
    registrationError: state.auth.registrationError,
    registrationCompleted: !!state.auth.successfullyRegisteredForEmail,
    emailResendInProgress: state.auth.emailResendInProgress,
});

export const selectLoginStatus = (state: RootState) => ({
    loginPageIsLoading: state.auth.loginPageIsLoading,
    loginPageError: state.auth.loginPageError,
    loginPageMailApproved: state.auth.loginPageMailApproved,
    emailApprovementInProgress: state.auth.emailApprovementInProgress,
});

export const selectUpdatePasswordStatus = (state: RootState) => ({
    updatePasswordPageIsLoading: state.auth.updatePasswordPageIsLoading,
    updatePasswordPageError: state.auth.updatePasswordPageError,
    updatePasswordApproved: state.auth.updatePasswordApproved,
});
